import { File } from '../file';
import { InternText } from '../intern/text';
import { ContentButton } from './button';

/**
 * Model definition for Split Paper
 */
export interface ContentSplitPaper {
  __component: 'content.split-paper';
  id: string;
  media?: File;
  button?: ContentButton;
  layout: 'textLeftImageHalf' | 'textLeftImageFull' | 'textRightImageHalf' | 'textRightImageFull';
  text?: InternText;
}

export function isSplitPaper(obj: { __component?: string }): obj is ContentSplitPaper {
  return obj.__component === 'content.split-paper';
}
